import { memo, useState } from "react";
import { Box } from "@mui/material";

import RoomDialog from "./dialogComponents/RoomDialog";
import ArbeitsplaetzeSection from "./sectionCards/arbeitsplaetzeSection/ArbeitsplaetzeSection";

import BszWoIstSection from "./sectionCards/woIstSection/BszWoIstSection";
import BszWerHilftSection from "./sectionCards/werHilftSection/BszWerHilftSection";
import BszKlassenOverviewSection from "./sectionCards/klassenuebersichtSection/BszKlassenOverviewSection";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

function BSZMain({ rooms = [], dialogs, actions, viewMode = "all" }) {
  const [selectedRoom, setSelectedRoom] = useState(null);
  const { isATeacher } = useAppContext();

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* ✅ TOP: TWO COLUMN AREA */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ flex: "1 1 200px", minWidth: 0 }}>
            <BszWerHilftSection />
          </Box>

          <Box sx={{ flex: "1 1 150px", minWidth: 0 }}>
            <BszWoIstSection />
          </Box>
        </Box>

        {/* ✅ MIDDLE: KLASSENÜBERSICHT */}
        {isATeacher && <BszKlassenOverviewSection />}

        {/* ✅ BOTTOM: ROOMS */}
        <ArbeitsplaetzeSection
          rooms={rooms}
          dialogs={dialogs}
          actions={actions}
          onSelectRoom={setSelectedRoom}
          viewMode={viewMode}
        />
      </Box>

      {/* ✅ ROOM DIALOG */}
      <RoomDialog room={selectedRoom} onClose={() => setSelectedRoom(null)} />
    </>
  );
}

export default memo(BSZMain);
